export default {"src":"/_next/static/media/icon_store_promo_check.a1d40cf1.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};